import {Component, Input, OnInit} from '@angular/core';
import {NoResults} from '../../models/no-results';

@Component({
  selector: 'cmp-not-results',
  template: `<div [style.margin-top.px]="errorHeightMarginTop">
  <img *ngIf="isRobotSnippet && robotWidthPercent == null && robotWidthPx == null"
       [ngClass]="robotClass"
       [style.height.px]="robotHeight"
       [style.width.%]="robotWidthPercent"
       src="assets/images/default/noresults.svg"/>
  <img *ngIf="isRobotSnippet && robotWidthPercent != null && robotWidthPx == null"
       [ngClass]="robotClass"
       [style.height.px]="robotHeight"
       [style.width.%]="robotWidthPercent"
       src="assets/images/default/noresults.svg"/>
  <img *ngIf="isRobotSnippet && robotWidthPx != null && robotWidthPercent == null"
       [ngClass]="robotClass"
       [style.height.px]="robotHeight"
       [style.width.px]="robotWidthPx"
       src="assets/images/default/noresults.svg"/>
  <h5
    *ngIf="errorMessage"
    [ngClass]="errorClass"
    [class.mb-0]="true"
    [style.font-size.px]="errorFontSize">
    {{errorMessage}}
  </h5>
</div>
`,
  styles: [`:host{display:block}.no-result-image{display:block;margin:0 auto}`]
})
export class NotResultsComponent implements OnInit {

  errorMessage = '';
  errorFontSize: string | number;
  errorClass = 'text-center font-weight-light text-primary mt-3 mb-0';
  errorHeightMarginTop: string | number;
  isRobotSnippet = true;
  robotClass = ' no-result-image ';
  robotHeight: string | number;
  robotWidthPx: string | number;
  robotWidthPercent: string | number;

  @Input()
  set noResults(
    {
      errorMessage,
      customErrorClass,
      errorFontSize,
      errorHeightMarginTop,
      isRobotSnippet,
      customRobotClass,
      robotHeight,
      robotWidthPx,
      robotWidthPercent
    }: NoResults) {
    this.errorMessage = errorMessage != null ? errorMessage : this.errorMessage;
    this.errorFontSize = errorFontSize != null ? errorFontSize : this.errorFontSize;
    this.errorClass = customErrorClass != null ? customErrorClass : this.errorClass;
    this.errorHeightMarginTop = errorHeightMarginTop != null ? errorHeightMarginTop : this.errorHeightMarginTop;
    this.isRobotSnippet = isRobotSnippet != null ? isRobotSnippet : this.isRobotSnippet;
    this.robotClass += customRobotClass;
    this.robotHeight = robotHeight != null ? robotHeight : this.robotHeight;
    this.robotWidthPx = robotWidthPx != null ? robotWidthPx : this.robotWidthPx;
    this.robotWidthPercent = robotWidthPercent != null ? robotWidthPercent : this.robotWidthPercent;
  }

  constructor() {
  }

  ngOnInit() {
  }

}
